import { useAccount, useConnect, useDisconnect } from 'wagmi'
import { LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { shortAddress } from '@/lib/utils'

export function ConnectButton() {
    const { address, isConnected } = useAccount()
    const { connectors, connect, status } = useConnect()
    const { disconnect } = useDisconnect()

    if (isConnected && address) {
        return (
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="outline" size="sm" className="font-mono">
                        {shortAddress(address)}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    <DropdownMenuItem onSelect={() => disconnect()}>
                        <LogOut className="mr-2 h-4 w-4" /> Disconnect
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        )
    }

    if (connectors.length === 1) {
        return (
            <Button
                size="sm"
                disabled={status === 'pending'}
                onClick={() => connect({ connector: connectors[0] })}
            >
                Connect wallet
            </Button>
        )
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button size="sm" disabled={status === 'pending'}>
                    Connect wallet
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {connectors.map((c) => (
                    <DropdownMenuItem key={c.uid} onSelect={() => connect({ connector: c })}>
                        {c.name}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
